export default Object.freeze({
    STEAM: 'steam',
    COOLING: 'cooling',
    CLOSED: 'closed',
    PURE: 'pure',
    WAST: 'waste',
    DOMESTIC: 'domestic',
    INDUSTRIALWATER: 'industrial-water',
    GENERIC: 'generic',
    AIRCONDITIONER: 'air-conditioner',
    CLOSEDLOOP: 'closed-loop',
});
